'use client'

import { useState } from 'react'
import { usePathname } from 'next/navigation'
import { ArrowRight, Eye, EyeOff, Loader2 } from 'lucide-react'
import { useLoginForm } from '@/lib/commerce/hooks'
import { navigateUrl } from '@/utils/client-request'

const inputStyle: React.CSSProperties = {
  background: 'rgba(255,255,255,0.035)',
  border: '1px solid rgba(255,255,255,0.07)',
  color: 'white',
}

export default function Login({ vendor }: { vendor?: any }) {
  void vendor
  const pathname = usePathname()
  const f = useLoginForm({ defaultRedirect: '/', refreshAfter: true, clearErrorParam: true })
  const [showPassword, setShowPassword] = useState(false)

  return (
    <div className="w-full">
      <div className="text-[10px] font-semibold uppercase tracking-[0.22em]" style={{ color: '#a8a8b3' }}>Бүртгэл</div>
      <h1
        className="mt-3 font-semibold tracking-[-0.025em] leading-[0.95] text-white"
        style={{ fontFamily: 'Gilroy, Inter, sans-serif', fontSize: 'clamp(30px, 4vw, 38px)' }}
      >
        Тавтай морил.
      </h1>

      <form onSubmit={f.handleLogin} className="mt-8 space-y-4">
        <div>
          <label className="block text-[11px] font-semibold uppercase tracking-[0.18em] mb-2" style={{ color: 'rgba(255,255,255,0.7)' }}>
            Имэйл / Утас
          </label>
          <input
            value={f.emailOrPhone}
            onChange={(e) => f.setEmailOrPhone(e.target.value)}
            onKeyDown={f.handleKeyDown}
            type="text"
            autoFocus
            placeholder="mail@shop.mn эсвэл 00000000"
            className="w-full h-12 rounded-full px-5 text-[13.5px] outline-none focus:ring-0 placeholder:text-white/30"
            style={inputStyle}
          />
        </div>
        <div>
          <div className="flex items-center justify-between mb-2">
            <label className="block text-[11px] font-semibold uppercase tracking-[0.18em]" style={{ color: 'rgba(255,255,255,0.7)' }}>
              Нууц үг
            </label>
            <a href={navigateUrl('/forgot', pathname)} className="text-[11px] font-medium text-white hover:underline">
              Мартсан уу?
            </a>
          </div>
          <div className="relative">
            <input
              value={f.password}
              onChange={(e) => f.setPassword(e.target.value)}
              onKeyDown={f.handleKeyDown}
              type={showPassword ? 'text' : 'password'}
              placeholder="Таны нэвтрэх нууц үг"
              className="w-full h-12 rounded-full pl-5 pr-12 text-[13.5px] outline-none focus:ring-0 placeholder:text-white/30"
              style={inputStyle}
            />
            <button
              type="button"
              onClick={() => setShowPassword(s => !s)}
              aria-label={showPassword ? 'Нууц үг нуух' : 'Нууц үг харах'}
              className="absolute right-4 top-1/2 -translate-y-1/2 transition-colors hover:text-white"
              style={{ color: 'rgba(255,255,255,0.5)' }}
            >
              {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
          </div>
        </div>

        <button
          type="submit"
          disabled={f.loading}
          className="w-full h-12 rounded-full text-[14px] font-medium inline-flex items-center justify-center gap-2 transition-opacity disabled:opacity-60"
          style={{ background: 'white', color: '#0a0a0c' }}
        >
          {f.loading ? (
            <><Loader2 className="h-4 w-4 animate-spin" /> Нэвтэрч байна...</>
          ) : (
            <>Нэвтрэх <ArrowRight className="h-3.5 w-3.5" /></>
          )}
        </button>
      </form>

      <p className="mt-7 text-center text-[13px]" style={{ color: 'rgba(255,255,255,0.6)' }}>
        Та шинэ хэрэглэгч үү?{' '}
        <button onClick={f.routeToRegister} className="text-white font-medium underline underline-offset-2 hover:opacity-80 transition-opacity cursor-pointer">
          Бүртгэл үүсгэх
        </button>
      </p>
    </div>
  )
}
